import {z} from 'zod';

import {conditionsToRegex} from '../../utils/utils';

export const passwordFieldSchema = z
  .string()
  .refine(
    value => Object.values(conditionsToRegex).every(re => re.test(value)),
    {
      message: 'Passwort erfüllt nicht alle Anforderungen.',
    },
  )
  .refine(value => !/\s/.test(value), {
    message: 'Leerzeichen sind nicht erlaubt.',
  });

export const passwordChangeSchema = z
  .object({
    password: z.string().min(1, 'Aktuelles Passwort muss angegeben werden.'),
    passwordNew1: passwordFieldSchema,
    passwordNew2: z.string().min(1, 'Wiederholung muss angegeben werden.'),
  })
  .refine(data => data.passwordNew1 === data.passwordNew2, {
    message: 'Die neuen Passwörter stimmen nicht überein.',
    path: ['passwordNew2'],
  });

export type PasswordChangeFormValues = z.infer<typeof passwordChangeSchema>;

export const passwordResetSchema = z
  .object({
    passwordNew1: passwordFieldSchema,
    passwordNew2: z.string().min(1, 'Wiederholung muss angegeben werden.'),
  })
  .refine(data => data.passwordNew1 === data.passwordNew2, {
    message: 'Die neuen Passwörter stimmen nicht überein.',
    path: ['passwordNew2'],
  });

export type PasswordResetFormValues = z.infer<typeof passwordResetSchema>;
